"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.calculateWidth = exports.getId = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var PageStrip_1 = require("./PageStrip");
var Pagination_st_css_1 = require("./Pagination.st.css");
var root_min_width_1 = require("./root-min-width");
var DataHooks_1 = require("./DataHooks");
var filter_data_props_1 = require("../../utils/filter-data-props");
var upperCaseFirst = function (str) {
    return str[0].toUpperCase() + str.slice(1);
};
exports.getId = function (idPrefix, name) {
    if (idPrefix === void 0) { idPrefix = ''; }
    if (name === void 0) { name = ''; }
    return idPrefix ? idPrefix + name : null;
};
exports.calculateWidth = function (totalPages) {
    return totalPages.toString().length + "em";
};
var Pagination = /** @class */ (function (_super) {
    tslib_1.__extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getMaxPagesToShow = function () {
            if (_this.props.maxPagesToShow) {
                return _this.props.maxPagesToShow;
            }
            if (_this.props.responsive) {
                return 20;
            }
            return 7;
        };
        _this.state = {
            pageInputValue: String(_this.props.currentPage),
            pageInputHasError: false,
        };
        _this.handlePageInputChange = function (e) {
            _this.setState({
                pageInputValue: e.target.value,
                pageInputHasError: false,
            });
        };
        _this.handlePageInputKeyDown = function (event) {
            // Enter
            if (event.key === 'Enter') {
                var page = Number(_this.state.pageInputValue);
                if (page !== _this.props.currentPage) {
                    if (1 <= page && page <= _this.props.totalPages) {
                        _this.props.onChange({ event: event, page: page });
                    }
                    else {
                        _this.setState({ pageInputHasError: true });
                    }
                }
            }
        };
        _this.handlePageInputBlur = function (event) {
            _this.setState({
                pageInputValue: String(_this.props.currentPage),
                pageInputHasError: false,
            });
        };
        _this.handlePageClick = function (event, page) {
            _this.props.onChange({ event: event, page: page });
        };
        _this.handlePageKeyDown = function (event, page) {
            // Enter or Space
            if (event.key === 'Enter' || event.key === 'Space') {
                _this.props.onChange({ event: event, page: page });
            }
        };
        return _this;
    }
    Pagination.prototype.updateRootMinWidth = function () {
        root_min_width_1.measureAndSetRootMinWidth(this.rootNode, this.props.paginationMode, this.props.id);
    };
    Pagination.prototype.componentDidMount = function () {
        this.props.updateResponsiveLayout && this.updateRootMinWidth();
    };
    Pagination.prototype.componentDidUpdate = function () {
        this.props.updateResponsiveLayout && this.updateRootMinWidth();
    };
    Pagination.prototype.getId = function (elementName) {
        if (elementName === void 0) { elementName = ''; }
        return exports.getId(this.props.id, elementName);
    };
    Pagination.prototype.renderPageStrip = function () {
        return (React.createElement(PageStrip_1.PageStrip, { id: this.props.id, totalPages: this.props.totalPages, currentPage: this.props.currentPage, maxPagesToShow: this.getMaxPagesToShow(), showFirstPage: this.props.showFirstPage, showLastPage: this.props.showLastPage, responsive: this.props.responsive, pageUrl: this.props.pageUrl, gapLabel: this.props.gapLabel, onPageClick: this.handlePageClick, onPageKeyDown: this.handlePageKeyDown, updateResponsiveLayout: this.props.updateResponsiveLayout, disabled: this.props.disabled }));
    };
    Pagination.prototype.renderPages = function () {
        switch (this.props.paginationMode) {
            case "input" /* Input */:
                return this.renderPageForm();
            case "compact" /* Compact */:
                return this.renderPageCompact();
            case "pages" /* Pages */:
            default:
                return this.renderPageStrip();
        }
    };
    Pagination.prototype.renderPageCompact = function () {
        return (React.createElement("div", { "data-hook": DataHooks_1.PaginationDataHooks.pageCompact, id: this.getId('pageCompact'), className: Pagination_st_css_1.classes.compact },
            React.createElement("span", { id: this.getId('currentPage'), "data-hook": DataHooks_1.PaginationDataHooks.currentPage }, this.props.currentPage),
            React.createElement("span", { id: this.getId('slash'), className: Pagination_st_css_1.classes.slash, "data-hook": DataHooks_1.PaginationDataHooks.slashLabel }, this.props.slashLabel),
            React.createElement("span", { id: this.getId('totalPages'), "data-hook": DataHooks_1.PaginationDataHooks.totalPages }, this.props.totalPages)));
    };
    Pagination.prototype.renderPageForm = function () {
        return (React.createElement("div", { "data-hook": DataHooks_1.PaginationDataHooks.pageForm, id: this.getId('pageForm'), className: Pagination_st_css_1.classes.pageForm, dir: "ltr" },
            React.createElement("input", { id: this.getId('pageInput'), "data-hook": DataHooks_1.PaginationDataHooks.pageInput, type: "number", className: Pagination_st_css_1.classes.pageInput, min: 1, max: this.props.totalPages, value: this.state.pageInputValue, disabled: this.props.disabled, onChange: this.handlePageInputChange, onKeyDown: this.handlePageInputKeyDown, "aria-label": 'Page number, select a number between 1 and ' +
                    this.props.totalPages, onBlur: this.handlePageInputBlur, style: { width: exports.calculateWidth(this.props.totalPages) } }),
            this.props.showInputModeTotalPages && [
                React.createElement("span", { key: "slash", id: this.getId('slash'), className: Pagination_st_css_1.classes.slash }, this.props.slashLabel),
                React.createElement("span", { key: "total-pages", id: this.getId('totalPages'), "data-hook": DataHooks_1.PaginationDataHooks.totalPages, className: Pagination_st_css_1.classes.totalPages }, this.props.totalPages),
            ]));
    };
    Pagination.prototype.renderEmptyButton = function (type) {
        var _a;
        var btnClass = (_a = {},
            _a["previous" /* Prev */] = [Pagination_st_css_1.classes.emptyButtonPrevious],
            _a["next" /* Next */] = [Pagination_st_css_1.classes.emptyButtonNext],
            _a)[type];
        return (React.createElement("div", { "data-hook": DataHooks_1.PaginationDataHooks[type], className: Pagination_st_css_1.st.apply(void 0, tslib_1.__spreadArrays([Pagination_st_css_1.classes.emptyButton], btnClass)) }));
    };
    Pagination.prototype.renderNavButton = function (type) {
        var _a;
        var _this = this;
        var _b = this.props, currentPage = _b.currentPage, totalPages = _b.totalPages, pageUrl = _b.pageUrl;
        var disabled = this.props.disabled ||
            ((type === "first" /* First */ || type === "previous" /* Prev */) &&
                currentPage <= 1) ||
            ((type === "last" /* Last */ || type === "next" /* Next */) &&
                currentPage >= totalPages);
        var _c = (_a = {},
            _a["previous" /* Prev */] = [
                Pagination_st_css_1.classes.navButtonPrevious,
                this.props.previousLabel,
                currentPage - 1,
            ],
            _a["next" /* Next */] = [
                Pagination_st_css_1.classes.navButtonNext,
                this.props.nextLabel,
                currentPage + 1,
            ],
            _a["first" /* First */] = [Pagination_st_css_1.classes.navButtonFirst, this.props.firstLabel, 1],
            _a["last" /* Last */] = [
                Pagination_st_css_1.classes.navButtonLast,
                this.props.lastLabel,
                totalPages,
            ],
            _a)[type], btnClass = _c[0], label = _c[1], page = _c[2];
        return (React.createElement("a", { "data-hook": DataHooks_1.PaginationDataHooks[type], id: this.getId('navButton' + upperCaseFirst(type)), className: Pagination_st_css_1.st(Pagination_st_css_1.classes.navButton, { disabled: disabled }, btnClass), "aria-label": upperCaseFirst(type) + ' Page', "aria-disabled": disabled, tabIndex: disabled || pageUrl ? null : 0, onClick: disabled ? null : function (event) { return _this.handlePageClick(event, page); }, onKeyDown: disabled ? null : function (event) { return _this.handlePageKeyDown(event, page); }, href: !disabled && pageUrl ? pageUrl(page) : null }, label));
    };
    Pagination.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({
            pageInputValue: String(nextProps.currentPage),
            pageInputHasError: false,
        });
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, showFirstLastNavButtons = _a.showFirstLastNavButtons, showNextLabel = _a.showNextLabel, showPreviousLabel = _a.showPreviousLabel, width = _a.width, inlineStyle = _a.style;
        var styleStates = {
            disabled: disabled,
            error: this.state.pageInputHasError,
        };
        return (React.createElement("nav", tslib_1.__assign({ ref: function (el) { return (_this.rootNode = el); }, id: this.getId(''), "aria-label": "Pagination Navigation", "aria-disabled": disabled, dir: this.props.rtl ? 'rtl' : null, onClick: this.props.onClick, onDoubleClick: this.props.onDoubleClick, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, style: inlineStyle || { width: width }, className: Pagination_st_css_1.st(Pagination_st_css_1.classes.root, styleStates, this.props.className) }, filter_data_props_1.filterDataProps(this.props)),
            showFirstLastNavButtons && this.renderNavButton("first" /* First */),
            showPreviousLabel
                ? this.renderNavButton("previous" /* Prev */)
                : this.renderEmptyButton("previous" /* Prev */),
            this.renderPages(),
            showNextLabel
                ? this.renderNavButton("next" /* Next */)
                : this.renderEmptyButton("next" /* Next */),
            showFirstLastNavButtons && this.renderNavButton("last" /* Last */)));
    };
    Pagination.displayName = 'Pagination';
    Pagination.defaultProps = {
        currentPage: 1,
        showFirstLastNavButtons: false,
        showFirstPage: false,
        showLastPage: false,
        showNextLabel: true,
        showPreviousLabel: true,
        responsive: false,
        paginationMode: 'pages',
        showInputModeTotalPages: false,
        disabled: false,
        // dir="rtl" automatically flips the direction of less-than and more-than signs.
        // If we decide to use different labels we need to add conditional logic.
        firstLabel: '<<',
        lastLabel: '>>',
        previousLabel: '<',
        nextLabel: '>',
        gapLabel: '...',
        slashLabel: '\u00A0/\u00A0',
    };
    return Pagination;
}(React.Component));
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map